import { ExternalLink, ShieldCheck } from "lucide-react";
import { fmtDate } from "@/lib/api";
import { LeaningBadge } from "@/components/Leaning";

const ROLE = { original: "Original source:", corroborating: "Confirmed by", conflicting: "Conflicting report from" };

const events = (f) => {
  const seen = new Set();
  const refs = [["original", f.original], ...(f.conflicting || []).map((r) => ["conflicting", r]), ...(f.corroborating || []).map((r) => ["corroborating", r])]
    .filter(([, r]) => r && !seen.has(r.record_id || r.url) && seen.add(r.record_id || r.url))
    .map(([role, r]) => ({ kind: role, at: r.published_at || "", r }));
  const dated = [...refs.filter((e) => e.at), ...(f.checked_at ? [{ kind: "checked", at: f.checked_at }] : [])].sort((a, b) => (Date.parse(a.at) || 0) - (Date.parse(b.at) || 0));
  return [...dated, ...refs.filter((e) => !e.at)];
};

const Dot = ({ kind }) => kind === "checked"
  ? <span className="absolute -left-[37px] top-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-[hsl(var(--facts))] text-white"><ShieldCheck size={13} /></span>
  : <span className={`absolute -left-[31px] top-1.5 h-3 w-3 rounded-full border-2 border-white ${kind === "conflicting" ? "bg-amber-500" : "bg-slate-400"}`} />;

export const ProvenanceTimeline = ({ f }) => (
  <ol className="relative ml-3 space-y-5 border-l-2 border-border pl-6" data-testid="fact-provenance-timeline">
    {events(f).map((e, i) => (
      <li key={`${e.kind}-${e.r?.record_id || i}`} className="relative" data-testid={`provenance-event-${i}`}>
        <Dot kind={e.kind} />
        <p className="text-xs text-slate-500" data-testid={`provenance-event-time-${i}`}>{e.at ? fmtDate(e.at) : "Date not provided by source"}</p>
        {e.kind === "checked"
          ? <p className="text-sm font-semibold text-[hsl(var(--facts))]">Middle checked it · {f.status}</p>
          : <p className="flex flex-wrap items-center gap-2 text-sm text-slate-800"><span className="text-slate-500">{ROLE[e.kind]}</span><b className="font-semibold">{e.r.source_name}</b>{e.r.leaning && <LeaningBadge leaning={e.r.leaning} />}
            {e.r.url && <a href={e.r.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 text-xs font-medium text-[hsl(var(--facts))] hover:underline" data-testid={`provenance-link-${i}`}>Original<ExternalLink size={11} /></a>}</p>}
      </li>
    ))}
  </ol>
);
